import { SxStyleProp } from 'rebass'

export const FButtonDefaultStyle: SxStyleProp = {
    px: 6,
    borderRadius: 1,
    boxShadow: 'main',
    height: '46px',
    cursor: 'pointer',
    border: 'none',
    outline: 'none',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s',
}

export const FButtonDefaultTextStyle: SxStyleProp = {
    letterSpacing: '0.02em',
    fontWeight: 'semiBold',
    fontSize: 3,
    lineHeight: '40px',
}
